module.exports = __webpack_public_path__ + "static/media/ShamanicMaleFigures.b3f8d600.png";